import storeFactory from '@/helpers/storeFactory'
import { format } from 'date-fns'
import isEqual from 'lodash.isequal'

export default storeFactory({
  model: {
    body: []
  },
  state: {
    form: {}
  },
  getters: {
    diffTrainDeviationsCancelSections(state, _, rootState) {
      const diffTrainDeviationModel = Object.values(state.form).filter(x => {
        if (!x || !x.trip_uuid) return false

        const tripCurrent = rootState?.smsMessage?.model?.trips?.find(
          y => y?.trip_uuid === x?.trip_uuid
        )

        const trainDeviation = rootState.trainDeviation.data[x.trip_uuid]
        const isChecked = trainDeviation && trainDeviation.checked

        const duaCancellation = (tripCurrent?.data?.cancel_sections || [])
          .slice()
          .sort((a, b) => a.index - b.index)
        const newDuaCancellation = (x?.data?.cancel_sections || [])
          .slice()
          .sort((a, b) => a.index - b.index)

        const isDiff =
          isChecked &&
          tripCurrent &&
          (newDuaCancellation.some((value, index) => {
            return !isEqual(value, duaCancellation[index])
          }) ||
            duaCancellation.length !== newDuaCancellation.length ||
            tripCurrent?.data?.reason_code !== x?.data?.reason_code ||
            tripCurrent?.data?.sms_text !== x?.data?.sms_text)

        return isDiff
      })
      return diffTrainDeviationModel
    },

    diffTrainDeviations(state, _, rootState) {
      const diffTrainDeviationModel = Object.values(state.form).filter(x => {
        if (!x || !x.trip_uuid) return false
        const tripCurrent = rootState?.smsMessage?.model?.trips?.find(
          y => y?.trip_uuid === x?.trip_uuid
        )
        // if (tripCurrent && tripCurrent.data.cancel_sections) return false

        const trainDeviation = rootState.trainDeviation.data[x.trip_uuid]
        const isChecked = trainDeviation && trainDeviation.checked
        const duaCancellationCode = () => tripCurrent.data.dua_cancellation_code
        const newDuaCancellationCode = () => x.data.dua_cancellation_code

        const duaReferenceCode = () => tripCurrent.data.dua_reference_code
        const newDuaReferenceCode = () => x.data.dua_reference_code

        const duaReasonCode = () => tripCurrent.data.reason_code
        const newDuaResonCode = () => x.data.reason_code

        const smsText = () => tripCurrent.data.sms_text
        const newSmsText = () => x.data.sms_text

        const replacementFromPlace = () =>
          tripCurrent.data.replacement_from_place
        const newReplacementFromPlace = () => x.data.replacement_from_place

        const replacementToPlace = () => tripCurrent.data.replacement_to_place
        const newReplacementToPlace = () => x.data.replacement_to_place

        const duaEstimatedTimeAtLocation = () =>
          tripCurrent.data.estimated_time_at_location
            ? format(
                new Date(tripCurrent.data.estimated_time_at_location),
                'yyyy-MM-dd, HH:mm'
              )
            : null
        const newDuaEstimatedTimeAtLocation = () =>
          x.data.estimated_time_at_location
            ? format(
                new Date(x.data.estimated_time_at_location),
                'yyyy-MM-dd, HH:mm'
              )
            : null

        // JUST NU VILL VI INTE JÄMNFÖRA MISC OCH PARAMETERAR EFTERSOM DESSA ALDRIG SÄTTS PÅ FRONTEND

        // const duaMiscCode = () => tripCurrent.data.dua_misc_code
        // const newDuaMiscCode = () => x.data.dua_misc_code

        // const duaParemeters = () => JSON.stringify(tripCurrent.data.parameters)
        // const newDuaParameters = () => JSON.stringify(x.data.parameters)

        // return (
        //   isChecked &&
        //   tripCurrent &&
        //   (duaCancellationCode() !== newDuaCancellationCode() ||
        //     duaReferenceCode() !== newDuaReferenceCode() ||
        //     duaReasonCode() !== newDuaResonCode() ||
        //     duaEstimatedTimeAtLocation() !== newDuaEstimatedTimeAtLocation() ||
        //     duaMiscCode() !== newDuaMiscCode() ||
        //     duaParemeters() !== newDuaParameters())
        // )

        return (
          isChecked &&
          tripCurrent &&
          (replacementToPlace() !== newReplacementToPlace() ||
            replacementFromPlace() !== newReplacementFromPlace() ||
            duaCancellationCode() !== newDuaCancellationCode() ||
            duaReferenceCode() !== newDuaReferenceCode() ||
            duaReasonCode() !== newDuaResonCode() ||
            smsText() !== newSmsText() ||
            duaEstimatedTimeAtLocation() !== newDuaEstimatedTimeAtLocation())
        )
      })

      return diffTrainDeviationModel
    },

    diffItemsCount(state, getters) {
      return getters['newItemsCount'] + getters['missingItemsCount']
    },

    newItemsCount(_, getters, rootState) {
      const trainDeviations = Object.values(
        rootState.trainDeviation.data
      ).filter(x =>
        ['PARTIAL_CANCELLATION', 'CANCELED'].includes(x.deviation_type)
      )
      const currentTrainDeviations =
        rootState?.smsMessage?.model?.trips
          ?.map(x => x?.trip_uuid)
          ?.filter(Boolean) || []

      const diffTrainDeviationModel = getters['diffTrainDeviations']
      const diffTrainDeviationsCancelSectionsModel =
        getters['diffTrainDeviationsCancelSections']

      const checkedItems = trainDeviations.filter(x => x.checked && !x.deleted)

      return (
        checkedItems.filter(x => !currentTrainDeviations.includes(x.uuid))
          .length +
        diffTrainDeviationModel.length +
        diffTrainDeviationsCancelSectionsModel.length
      )
    },

    missingItemsCount(state, _, rootState) {
      const trainDeviations = rootState.trainDeviation.data
      const duaMessageModel = rootState.smsMessage.model

      const train_deviations = [
        ...new Set([
          ...(duaMessageModel?.trips?.map(x => x?.trip_uuid).filter(Boolean) ||
            [])
        ])
      ]

      const missingItems = train_deviations.filter(
        uuid => trainDeviations[uuid] && !trainDeviations[uuid].checked
      )
      return missingItems.length
    }
  },
  actions: {
    updateForm({ state, commit }, { uuid, prop, value }) {
      const form = Object.assign({}, state.form)
      form[uuid].data[prop] = value
      commit('SET_FORM', form)
    },
    setFormChecked({ state, commit }, { uuid, value }) {
      const form = Object.assign({}, state.form)
      form[uuid]._checked = value
      commit('SET_FORM', form)
    },
    setForm({ commit, state, rootState, rootGetters }) {
      const currentBody = (state?.model?.trips || [])?.map(x => ({
        trip_uuid: x?.trip_uuid,
        data: Object.assign({}, x?.data || {})
      }))

      const getReasonCode = () => {
        const event = rootGetters['event/selectedEvent']
        if (!event) return null
        const reason = rootState.duaMessage.duaReasonCodes.find(
          x =>
            event.reason &&
            event.reason.name.toLowerCase().trim() ===
              x.text.toLowerCase().trim()
        )
        return reason ? reason.code : null
      }

      const tripDeviations = Object.values(
        rootState.trainDeviation.data
      ).filter(x =>
        ['PARTIAL_CANCELLATION', 'CANCELED'].includes(x.deviation_type)
      )

      const checkedTripDeviations = tripDeviations
        .filter(
          x =>
            x.checked &&
            (!currentBody ||
              (currentBody && !currentBody.some(y => y?.trip_uuid === x.uuid)))
        )
        .map(x => {
          const body = !currentBody.find(y => y?.trip_uuid === x.uuid)
          const trip = tripDeviations.find(y => y.uuid === x.uuid)
          return {
            trip_uuid: x.uuid,
            data: {
              // replacement_from_place: null,

              // replacement_to_place: null,
              // dua_cancellation_code: ['INCREASED', 'DECREASED'].includes(
              //   x.deviation_type
              // )
              //   ? null
              //   : 'ANA027',
              // dua_reference_code: ['INCREASED', 'DECREASED'].includes(
              //   x.deviation_type
              // )
              //   ? null
              //   : 'ANA075',
              // parameters: null,
              sms_text: null,
              reason_code: ['INCREASED', 'DECREASED'].includes(x.deviation_type)
                ? null
                : getReasonCode(),
              cancel_sections:
                !body || !body.data?.cancel_sections.length
                  ? [
                      {
                        from: trip?.from,
                        to: trip?.to,
                        dua_cancellation_code: 'ANA027',
                        dua_reference_code: 'ANA075',
                        estimated_time_at_location: null,
                        departure: trip.departure
                          ? +new Date(trip.departure)
                          : null,
                        arrival: trip.arrival ? +new Date(trip.arrival) : null,
                        index: 0
                      }
                    ]
                  : []
            }
          }
        })
      const newForm = [...currentBody, ...checkedTripDeviations]
        .map(x => {
          const trip = state.form[x?.trip_uuid]
          if (trip) {
            return {
              ...trip,
              data: Object.assign({}, trip.data)
            }
          }
          return x
        })
        .reduce((acc, item) => {
          acc[item?.trip_uuid] = {
            ...item,
            _checked: false
          }

          return acc
        }, {})

      commit('SET_FORM', newForm)
    }
  }
})
